module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "OtherBooks",
      "title": "Other Books"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "otherbooksheader"
  }, [_vm._v("Books by Charles G. Irion and Ronald J. Watkins")]), _vm._v(" "), _c('p', {
    staticClass: "otherbookssubheader"
  }, [_vm._v("The Summit Murder Mystery Series")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Murder on Everest")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Abandoned on Everest (a prequel to Murder on Everest)")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Murder on Elbrus")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Murder on Mt. McKinley")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Murder on Puncak Jaya (Summer 2011)")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Murder on Aconcagua (Winter 2012)")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Murder on Vinson Massif (Summer 2012)")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Murder on Kilimanjaro (Winter 2013)")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooksheader"
  }, [_vm._v("Books by Charles G. Irion")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Remodeling Hell")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Autograph Hell")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Car Dealer Hell")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Divorce Hell")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Roadkill Cooking for Campers (Wild Game Cookbook)")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooksheader"
  }, [_vm._v("Books by Ronald J. Watkins")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Unknown Seas")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Birthright")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Cimmerian")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Evil Intentions")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Against Her Will")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("A Suspicion of Guilt")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("A Deadly Glitter")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Alter Ego")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("Shadows and Lies")]), _vm._v(" "), _c('p', {
    staticClass: "otherbooks"
  }, [_vm._v("High Crimes and Misdemeanors")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaba4ecc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/OtherBooks.vue
// module id = 60
// module chunks = 0